import Vue from 'vue';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class UseResultService extends Vue {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();


  async getUseResult(param: any) {
    let q = "?q=groupCd=" + param.groupCd +
      ",shatenCd=" + param.shatenCd +
      ",dateFrom=" + param.dateFrom +
      ",dateTo=" + param.dateTo;
    const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/use-result${q}`);
    if (result) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getUseResult');
      return null;
    }
  }
}
